<template>
  <span class="hc-router-link-container" @click="handleClick">
    <slot></slot>
  </span>
</template>

<script>
import { resolveVueRouterAndOpenNewTab } from '@/services/utils/modules/routerWrapper'
export default {
  props: {
    to: {
      type: [Object, String],
      default: () => ({}),
    },
    newTab: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    handleClick() {
      if (this.newTab) {
        // new tag
        if (typeof this.to === 'string' && this.to.startsWith('http')) {
          // app external link
          window.open(this.to)
        } else {
          // app inner link
          resolveVueRouterAndOpenNewTab(this.to)
        }
      } else {
        if (typeof this.to === 'string' && this.to.startsWith('http')) {
          location.href = this.to
        } else {
          this.$router.push(this.to)
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.hc-router-link-container {
  cursor: pointer;
  color: $main-color;
}
</style>
